<template>
    <div class="vrm-header" :class="headerClass">
        <div class="container hide-in-desktop">
            <div class="row">
                <div class="col-xs-12 vrm-header__inner">
                    <div class="vrm-nav-handle vrm-header__item" @click="onNavToggle">
                        <span class="sg-vrm-icon_032_menu-16px" />
                    </div>
                    <div
                        class="vrm-header__title-wrapper"
                        :class="{ 'vrm-header__title-wrapper--tasks': hasTitleTasks }"
                    >
                        <router-link
                            v-if="hasTitle || hasTitleTasks"
                            class="vrm-header__title"
                            :to="{
                                name: 'base.installation.dashboard',
                                params: { id: installation.id },
                            }"
                        >
                            <div class="vrm-header__title-content">
                                <slot v-if="hasTitle" name="header-title" />
                                <slot v-if="hasTitleTasks" name="header-title-tasks" />
                            </div>
                            <span class="sg-vrm-icon_142_chevron-left-m-20px" />
                        </router-link>
                    </div>
                    <div v-if="hasControls" class="vrm-header__controls hidden-lg">
                        <slot name="header-controls" />
                    </div>
                </div>
            </div>
        </div>
        <vrm-red-banner v-if="installation" :installation="installation" />
        <vrm-global-message />
        <vrm-two-fa-non-admin-banner />
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ngInject } from '@/vue/decorators/angular-interop';
import VrmGlobalMessage from '@/vue/components/shared/VrmGlobalMessage.vue';
import vrmRedBanner from '@/vue/components/shared/VrmRedBanner.vue';
import VrmTwoFaNonAdminBanner from '../shared/VrmTwoFaNonAdminBanner.vue';
@Component({
    components: {
        VrmGlobalMessage,
        vrmRedBanner,
        VrmTwoFaNonAdminBanner,
    },
})
export default class VrmHeader extends Vue {
    @Prop({ type: String, default: '' })
    headerClass;

    @Prop({ type: Object, default: null })
    installation;

    get hasControls() {
        return this.$slots['header-controls'];
    }
    get hasTitle() {
        return this.$slots['header-title'];
    }
    get hasTitleTasks() {
        return this.$slots['header-title-tasks'];
    }

    @ngInject()
    $rootScope;
    @ngInject()
    vrmNavToggleEvent;

    onNavToggle() {
        this.$rootScope.$emit(this.vrmNavToggleEvent.toggle);
    }
}
</script>
